exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gw-form-phone{display:block}@media (max-width:46.24em){gw-form-phone:last-of-type{margin-bottom:12px}}@media (min-width:46.25em){.gw-phone-country-code,.gw-phone-type{width:120px}}@media (max-width:46.24em){.gw-phone-type{margin-top:0}}@media (max-width:46.24em){.gw-phone-country-code,.gw-phone-input{margin-bottom:0}}.gw-phone-country-code__iso{text-transform:uppercase}md-option .gw-phone-country-code__iso{display:none}md-option .gw-phone-country-code__country,md-select-value .gw-phone-country-code__iso{display:inline}md-select-value .gw-phone-country-code__country{display:none}.gw-icon--phone{opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./resources/assets/js/common/forms/phone/phone.scss
// module id = BgKO
// module chunks = 1